// extracted by mini-css-extract-plugin
export default {"wrapper":"AddNoteCard_wrapper__g9GxU","title":"AddNoteCard_title__5Ikze","icon":"AddNoteCard_icon__X7GDa"};